import React from 'react'
import {
  Box, Text, Button, Anchor,
} from '@usap/uicomponents'

const RMAReturnButtons = props => {
  const {
    idName,
    buttonLabel,
    submitForm,
    displayCancelConfirmation,
    isPartEligible,
    setButtonText,
  } = props

  const DoneButton = () => {
    displayCancelConfirmation()
  }

  const btnLabel = buttonLabel
  let buttonStyle = {
    fontFamily: 'Roboto',
    fontSize: 16,
    letterSpacing: 0,
    textAlign: 'center',
    lineHeight: '40px',
    width: '226px',
    height: '46px',
  }
  if (!isPartEligible) {
    setButtonText('Done')
    buttonStyle = {
      ...buttonStyle,
      backgroundColor: '#fff',
      border: '2px solid #2E4787',
      color: '#2E4787',
    }
  }

  const displayCancel = buttonLabel === 'Done' ? 'none' : 'flex'

  return (
    <>
      <Box
        margin={{ bottom: '20px' }}
        style={{ textAlign: 'center', alignSelf: 'center' }}
      >
        <Button
          id={idName}
          primary
          onClick={submitForm}
          type="submit"
          custom
          hideBorder
          size="large"
          label={btnLabel}
          margin={{ horizontal: '45px', bottom: '16px', top: '0px' }}
          style={buttonStyle}
        />
        {isPartEligible && (
          <Anchor
            onClick={() => DoneButton()}
            size="large"
            style={{ textDecoration: 'none', lineHeight: '46px' }}
            alignSelf="center"
            justify="center"
            label={(
              <Text
                size="large"
                color="#DB2429"
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: 'normal',
                  fontSize: 16,
                  letterSpacing: 0,
                  display: displayCancel,
                  textAlign: 'center',
                }}
              >
                Cancel
              </Text>
            )}
          />
        )}
      </Box>
    </>
  )
}

export default RMAReturnButtons
